import { Box } from "@mui/material";
import { useAlertSourceStatusCharts } from "./alertStatusChart";
import { ResolutionsLineChart } from "./ResolutionsLineChart";

interface AlertsResolutionsByAlertDateMetricsProps {
  startDate: string;
  endDate: string;
  companyId: number | null;
}

const AUTO_LABELS = ["auto_resolved"];
const MANUAL_LABELS = ["resolved"];
const UNRESOLVED_LABELS = ["action_needed"];

export default function AlertsResolutionsByAlertDateMetrics(props: AlertsResolutionsByAlertDateMetricsProps) {
  const { data, loading } = useAlertSourceStatusCharts("resolutions_by_alert_date", ["ethoca", "cdrn"], props);
  const ethocaData = data.ethoca ?? null;
  const cdrnData = data.cdrn ?? null;

  const hasAnyData =
    (ethocaData && ethocaData.summary.total > 0) || (cdrnData && cdrnData.summary.total > 0);
  if (!loading && !hasAnyData) {
    return null;
  }

  return (
    <Box sx={{ mt: 3, display: "flex", gap: 3, flexWrap: { xs: "wrap", md: "nowrap" }, alignItems: "flex-start" }}>
      <ResolutionsLineChart
        title="Ethoca Resolutions by Alert Date (Manual vs Auto)"
        data={ethocaData}
        loading={loading}
        autoLabels={AUTO_LABELS}
        manualLabels={MANUAL_LABELS}
        manualSeriesLabel="Manually Resolved"
        unresolvedLabels={UNRESOLVED_LABELS}
      />
      <ResolutionsLineChart
        title="CDRN Resolutions by Alert Date (Manual vs Auto)"
        data={cdrnData}
        loading={loading}
        autoLabels={AUTO_LABELS}
        manualLabels={MANUAL_LABELS}
        manualSeriesLabel="Manually Resolved"
        unresolvedLabels={UNRESOLVED_LABELS}
      />
    </Box>
  );
}
